export default __webpack_public_path__ + "static/15-467c934e1088b914e988fa5992e080aa.webp";